import React, { useState, useEffect } from 'react';
import { isMobile } from "react-device-detect"
import './graffiti.css';

const GraffitiWall = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API call to fetch data from MongoDB 
  const fetchImagesFromMongoDB = async () => {
     const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`

    try {
      // Fixed: Changed from /api/images to /images to match your server route
      const response = await fetch(`${adminPanel}/images`);
      
      if (!response.ok) {
        console.error('Failed to fetch images');
      }
      
      const data = await response.json();
      console.log('Fetched data:', data.data);
      
      // Handle the response structure from your server
      if (data.success && data.data) {
        return data.data;
      } else {
        throw new Error(data.message || 'No data received');
      }
    } catch (err) {
      console.error('API Error:', err.message);
      // For demo purposes, using mock data
      console.warn('Using mock data - replace with your actual API endpoint');
      return [
        { Firstname: 'Test', Image: 'https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/NPI%20Live%20Stream%202025%2Fcaptured-image%20(5).png?alt=media&token=3c060af2-1866-4c72-b51c-b07eb6f0fe32' },
        // { Firstname: 'Street Mural', Image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop' },
        // { Firstname: 'Graffiti Tag', Image: 'https://images.unsplash.com/photo-1544967082-d9759a04fa42?w=400&h=300&fit=crop' },
        // { Firstname: 'Wall Art', Image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400&h=300&fit=crop' },
        // { Firstname: 'Color Splash', Image: 'https://images.unsplash.com/photo-1578321272176-b7bbc0679853?w=400&h=300&fit=crop' },
        // { Firstname: 'Urban Canvas', Image: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=400&h=300&fit=crop' },
        // { Firstname: 'Street Expression', Image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop' },
        // { Firstname: 'Artistic Wall', Image: 'https://images.unsplash.com/photo-1518621012112-d17cc29cd16d?w=400&h=300&fit=crop' },
        // { Firstname: 'Vibrant Art', Image: 'https://images.unsplash.com/photo-1545163147-f8c90459c667?w=400&h=300&fit=crop' },
        // { Firstname: 'Creative Expression', Image: 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?w=400&h=300&fit=crop' }
      ];
    }
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        setLoading(true);
        const imageData = await fetchImagesFromMongoDB();
        setImages(imageData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, []);

  const getRandomRotation = () => {
    return Math.random() * 10 - 5; // Random rotation between -5 and 5 degrees
  };

  const getRandomDelay = (index) => {
    return index * 0.1 + Math.random() * 0.5; // Staggered animation delays
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner">
            {/* hello */}
          </div>
          <p className="loading-text">Loading Gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-content">
          <h2 className="error-title">Oops! Something went wrong</h2>
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="graffiti-wall-container">
      {/* Animated background elements */}
      <div className="background-elements">
        {/* <div className="bg-element-1"></div>
        <div className="bg-element-2"></div>
        <div className="bg-element-3"></div> */}
      </div>

      {/* Header */} 
      <div className="header-section">
        {/* <h1 className="main-title">GALLERY</h1> */}
        <header className="inv-headerr">
          <div className="inv-header-line inv-header-line--gold" />
          <h1 className="inv-header-title">
            <span className="inv-header-bracket">[</span>
            GALLERY
            <span className="inv-header-bracket">]</span>
          </h1>
          <div className="inv-header-line inv-header-line--gold" />
        </header>
        {/* <p className="subtitle">Apple Photobooth Collection</p> */}
        {/* <div className="title-underline"></div> */}
      </div>

      {/* Images Grid */}
      <div className="images-container">
        <div className="images-grid">
          {images.map((image, index) => (
            <div
              key={index}
              className="image-item animate-fade-in-up"
              style={{
                animationDelay: `${getRandomDelay(index)}s`,
                transform: `rotate(${getRandomRotation()}deg)`,
              }}
            >
              <div className="image-wrapper">
                {/* Polaroid-style frame */}
                <div className="polaroid-frame">
                  <img
                    src={image.Image}  // Changed from image.Image to image.firebaseUrl
                    alt={image.Firstname}      // Changed from image.Firstname to image.userName
                    className="polaroid-image"
                    loading="lazy"
                  />
                  
                  {/* Handwritten-style name */}
                  {/* <div className="image-name">
                    {image.Firstname}
                  </div> */}
                  
                  {/* Tape effect */}
                  <div className="tape-effect"></div>
                  
                  {/* Graffiti-style overlay on hover */}
                  {/* <div className="graffiti-overlay">
                    <div className="graffiti-text">
                      APPLE ART
                    </div>
                  </div> */}
                </div>
                
                {/* Neon glow effect */}
                <div className="neon-glow"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GraffitiWall;